// extracted by mini-css-extract-plugin
export default {"item":"transactionItem_item__16Ddj","itemMobile":"transactionItem_itemMobile__XegG5"};